import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { mobileLogger } from './app/core/mobile-logger';

mobileLogger.info('App', 'boot', {
  production: environment.production,
  backendUrl: environment.backendUrl,
  apiUrl: environment.apiUrl,
  occupantApiUrl: environment.occupantApiUrl,
  facilityApiUrl: environment.facilityApiUrl,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
